import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import useTranslation from "../../hooks/traslation";

const ManageProfile = () => {
  const navigate = useNavigate();
  const user = useAuth();
  const translation = useTranslation();

  return (
    <MainContainer>
      <div className="main_title">
        <h1> {translation.auth.mangeProfile}</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {translation.dashboard.dashboard}
          </span>{" "}
          - {translation.auth.mangeProfile}
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>{translation.main.generalDetail}</h2>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-profile/edit")}
            >
              <EditIcon /> {translation.auth.editProfile}
            </Button>
          </div>
        </div>
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>{translation.main.Image}</h6>
            <figure>
              <img
                alt="user"
                src={user?.image || "/static/images/user_placeholder.png"}
              />
            </figure>
          </div>
          <div className="w_33">
            <h6>{translation.globals.name}</h6>
            <p>{user?.name ? user?.name : "-"}</p>
          </div>
          <div className="w_33">
            <h6>{translation.main.email}</h6>
            <p>{user?.email || "-"}</p>
          </div>
          <div className="w_33">
            <h6>{translation.main.phone}</h6>
            <p> {user?.phoneNo ? user?.dialCode + " " + user?.phoneNo : "-"}</p>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default ManageProfile;
